/*
  Enum for Mapping Basesite to corresponding Currency
  this is needed to set the proper Currency on pageload
 */

export enum EuroCurrency {
  EURO = 'EUR',
}

export enum BasesiteCurrencyMap {
  'rentalGB' = 'GBP',
  'rentalSK' = 'EUR',
  'rentalPL' = 'PLN',
  'rentalHU' = 'HUF',
  'rentalCZ' = 'CZK',
  'rentalCH' = 'CHF',
  'rentalNL' = EuroCurrency.EURO,
  'rentalLU' = EuroCurrency.EURO,
  'rentalIT' = EuroCurrency.EURO,
  'rentalDE' = EuroCurrency.EURO,
  'rentalBE' = EuroCurrency.EURO,
  'rentalAT' = EuroCurrency.EURO,
  'rentalHR' = EuroCurrency.EURO,
  'rentalSI' = EuroCurrency.EURO,
}
